import { Link } from 'react-router-dom'
import { LuPlus } from 'react-icons/lu'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

export default function NetworksEmptyState() {
  return (
    <Box>
      <Stack sx={{
        gap: 3
      }}>
        <Typography variant="h2">Create a network</Typography>
        <Typography variant="body1">
          A network is a private overlay that links your machines across clouds and locations. Keys are issued
          automatically, only your nodes can talk, and every node sees a shared drive at <code>/mnt/nobgp</code> for
          configs and assets.
        </Typography>

        <Box>
          <Typography variant="subtitle2" sx={{
            marginBottom: 1
          }}>
            Why networks matter
          </Typography>
          <ul style={{ margin: 0, paddingLeft: 24 }}>
            <Typography component="li" variant="body2">
              <strong>Isolation:</strong> Nodes in one network are invisible to other networks
            </Typography>
            <Typography component="li" variant="body2">
              <strong>Secure:</strong> Every connection is encrypted end-to-end
            </Typography>
            <Typography component="li" variant="body2">
              <strong>Distributed:</strong> Spans clouds, data centers, and edge locations
            </Typography>
            <Typography component="li" variant="body2">
              <strong>Control:</strong> Use a separate key per group of nodes; OAuth enforces who can connect
            </Typography>
          </ul>
        </Box>

        <Box>
          <Typography variant="subtitle2" sx={{
            marginBottom: 1
          }}>
            Add one in seconds
          </Typography>
          <ol style={{ margin: 0, paddingLeft: 24 }}>
            <Typography component="li" variant="body2">
              Click "Add network"
            </Typography>
            <Typography component="li" variant="body2">
              Name it for the environment (production, staging, edge)
            </Typography>
            <Typography component="li" variant="body2">
              Connect nodes; add more keys later if you want to control who can add nodes
            </Typography>
          </ol>
        </Box>

        <Box>
          <Button component={Link} to="/network" startIcon={<LuPlus />} size="small" variant="outlined">
            Add a network
          </Button>
        </Box>
      </Stack>
    </Box>
  )
}
